import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './containers/layout/layout.component';
import { AuthGuardService } from './shared/foundation/auth/auth-guard.service';
import { LayoutV2Component } from './containers/layout/layout-v2.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutV2Component,
    data: {
      title: 'Portal',
    },
    children: [
      {
        canActivate: [AuthGuardService],
        path: '',
        loadChildren: () =>
          import('./views/portal/portal.module').then((m) => m.PortalModule),
      },
    ],
  },
  {
    path: 'pages',
    component: LayoutV2Component,
    data: {
      title: 'Pages',
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: 'auth',
    component: LayoutV2Component,
    data: {
      title: 'Auth',
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/auth/auth-pages.module').then(
            (m) => m.AuthPagesModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'pages',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
